import { bootstrapApplication } from '@angular/platform-browser';

import { partnerHandlers } from '@amp/testing/mocks/partner';
import { startDevMswWorker } from '@amp/testing/msw/browser';

import { appConfig } from './app/app.config';
import { App } from './app/app.component';

enableMocking()
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));

async function enableMocking(): Promise<void> {
  await startDevMswWorker(partnerHandlers);
}
